import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { BASE_URL, BASE_URL_ADMIN } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

/**
 * Service permettant de gérer les coûts
 * see {@link ICosts}
 */
@Injectable({ providedIn: 'root' })
export class CostsService extends ApiService {

  public typesUrl = BASE_URL_ADMIN + '/types';

  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * {@link ApiService#getAllObjet}
   */
  getAllObjet(req?: any) {
    super.getAllObjet(this.typesUrl, req);
  }
}